import { render, staticRenderFns } from "./TheDappHeader.vue?vue&type=template&id=4080c232&scoped=true"
import script from "./TheDappHeader.vue?vue&type=script&lang=js"
export * from "./TheDappHeader.vue?vue&type=script&lang=js"
import style0 from "./TheDappHeader.vue?vue&type=style&index=0&id=4080c232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4080c232",
  null
  
)

export default component.exports